<template>
  <div class="coupon-page">
    <v-header class="coupon-page_title">抵扣券</v-header>
    <ul class="coupon-page_type">
      <li
        class="coupon-page_type--item"
        @click="selectType('normal')"
        :class="couponType === 'normal' ? 'active' : false"
      >
        可使用
      </li>
      <li
        class="coupon-page_type--item"
        @click="selectType('used')"
        :class="couponType === 'used' ? 'active' : false"
      >
        已使用
      </li>
      <li
        class="coupon-page_type--item"
        @click="selectType('expiry')"
        :class="couponType === 'expiry' ? 'active' : false"
      >
        已過期
      </li>
    </ul>
    <transition-group name="list-change" tag="div" class="coupon-page_content">
      <div
        class="coupon-page_content--item"
        :key="couponItem.catalog"
        v-for="couponItem in coupons"
        v-show="couponType === couponItem.catalog"
      >
        <template v-if="couponItem.list.length">
          <div
            :key="coupon.COUPON_ID"
            class="coupon-item"
            v-for="coupon in couponItem.list"
          >
            <div class="coupon-item_left" :class="couponTypeClass">
              <span class="spec-value">{{ coupon.REDUCTION }}</span>
              <span class="spec-text">G幣</span>
              <span class="spec-tips">{{ coupon.limitText }}</span>
            </div>
            <div class="coupon-item_right">
              <p class="coupon-item_right-title">
                <span class="coupon-item_right-type">{{
                  coupon.couponType
                }}</span>
                <span class="coupon-item_right-desc">{{
                  coupon.couponDesc
                }}</span>
              </p>
              <div class="coupon-item_right-time">{{ coupon.timeText }}</div>
              <div
                class="coupon-item_right-use"
                :class="couponTypeClass"
                @click="useCoupon(coupon)"
              >
                {{ couponType === "normal" ? "使用" : "" }}
              </div>
              <span class="coupon-item_right-tips">
                <i class="coupon-item_right-icon"></i>不可疊加使用
              </span>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="coupon-page_content--item-empty">
            <img class="empty-image" :src="emptyImg" alt="emptyImage" />
            <p class="empty-text">{{ emptyText }}</p>
          </div>
        </template>
      </div>
    </transition-group>
  </div>
</template>

<script>
import vHeader from '@/components/header'
import emptyImg from '@/assets/empty-coupon.png'
export default {
  name: 'Coupon',
  components: {
    vHeader
  },
  data () {
    return {
      emptyImg,
      games: [],
      couponType: 'normal',
      coupons: {
        normal: {
          catalog: 'normal',
          list: []
        },
        used: {
          catalog: 'used',
          list: []
        },
        expiry: {
          catalog: 'expiry',
          list: []
        }
      }
    }
  },
  computed: {
    couponTypeClass () {
      let obj = {
        normal: '',
        used: 'used',
        expiry: 'out-date'
      }
      return obj[this.couponType]
    },
    emptyText () {
      let obj = {
        normal: '暫無可使用的抵扣券',
        used: '暫無已使用的抵扣券',
        expiry: '暫無已過期的抵扣券'
      }
      return obj[this.couponType]
    }
  },
  methods: {
    useCoupon (coupon) {
      if (this.couponType === 'normal') {
        this.$datain({ ext3: '可用折扣券-使用按钮', ext15: coupon.COUPON_ID })
        window.location.href = '//mstore.gm99.com'
      }
    },
    selectType (type) {
      this.couponType = type
      let typeObj = {
        normal: '可使用',
        used: '已使用',
        expiry: '已过期'
      }
      this.$datain({ ext3: `tap按钮-${typeObj[type]}` })
    },
    showTipsContent (content) {
      this.$store.commit('setTipsState', true)
      this.$store.commit('setTipsContent', content)
    },
    initCouponList (data) {
      function formatTimeText (str) {
        if (str.startsWith('9999')) {
          return '無限期'
        }
        let index = str.indexOf(' ')
        return str.substr(0, index).replace(/-/gi, '.')
      }
      let keys = ['normal', 'used', 'expiry']
      keys.forEach((key) => {
        this.coupons[key].list = data[key].map((coupon) => {
          let game = !+coupon.GAME_ID ? '' : coupon.GAME_NAME
          let extraText
          switch (coupon.LIMIT_FACTOR) {
            case '':
              extraText = '全品類商品'
              break
            case 'package':
              extraText = '禮包類商品'
              break
            case 'coin':
              extraText = '遊戲幣類商品'
              break
            default:
              extraText = coupon.PRODUCT_DESC
              break
          }
          coupon.couponType = `【${
            !coupon.LIMIT_FACTOR ? '通用券' : '限定券'
          }】`
          coupon.couponDesc = `可用於購買[${game || '所有遊戲'}]的${extraText || ''}`
          coupon.limitBottom = +coupon.LIMIT_BOTTOM
          coupon.limitText = coupon.limitBottom
            ? `滿${coupon.limitBottom}G幣可用`
            : '無門檻'
          coupon.timeText = `${formatTimeText(
            coupon.START_TIME
          )}-${formatTimeText(coupon.EXPIRY_TIME)}`
          return coupon
        })
      })
    },
    fetchUserData () {
      this.$jsonp('//mstore.gm99.com/points/user_data')
        .then((res) => {
          let data = res.data
          if (+res.result >= 1) {
            this.initCouponList(data.coupons)
            if (data.coupons.normal.length) {
              this.$datain({ ext3: '存在可使用券' })
            }
          } else {
            this.$store.commit('setTipsState', true)
            this.$store.commit('setTipsContent', res.msg)
          }
          this.$store.commit('setLoadingState', false)
        })
        .catch((err) => {
          this.$store.commit('setTipsState', true)
          this.$store.commit('setTipsContent', err.message || '系統錯誤')
        })
    }
  },
  async created () {
    this.fetchUserData()
  }
}
</script>

<style lang="scss" scoped>
@import "../scss/coupon.scss";
</style>
